<template>
  <div class="engraving sidebar-content">
    <transition name="fade">
      <pages v-if="manageElement == 'pages'" />
    </transition>
    <SidebarEngraving
      class="sidebar-engraving-panel"
      :class="{'open': showPanelElements }"
    />

    <div class="engraving-canvas">
      <div
        class="engraving-faces"
        v-if="elementsForEngraving&&elementsForEngraving.length"
      >
        <div
          class="engraving-faces-button desctop-view"
          v-if="faces&&faces.length"
        >

          <button
            v-for="(face,i) in faces"
            :key="`tab-faces-${face.face_id}`"
            :class="{ active: activeFace && activeFace.face_id == face.face_id}"
            @click="setActiveFace(face)"
            class="button-face text-sm"
          >
            <span class="face-name" v-html="face.faceName"></span>
            <i>{{i+1}}</i>
          </button>
        </div>
        <div
          class="engraving-faces-button adaptive-view"
          v-if="faces&&faces.length"
        >

          <button
            v-for="(face,i) in faces"
            :key="`tab-faces-${face.face_id}`"
            :class="{ active: activeFace && activeFace.face_id == face.face_id}"
            @click="setActiveFace(face)"
            class="button-face text-sm"
          >
            {{i+1}}
          </button>
        </div>
        <div
          v-else
          class="engraving-faces-button empty"
        >
          Выберите элемент для отображения граней
        </div>

        <ElementsForEngraving :elements="elementsForEngraving" />

        <ThreeSceneEngraving
          v-if="activeFace"
          :key="`canvas-faces-${activeFace.face_id}`"
          class="engraving-canvas-draw"
        />

        <element-engraving-setting />
      </div>
      <div
        v-else
        class="text-red-700 text-sm mt-4 ml-4"
      >
        {{$t('client.engraving_canvas.no_available_faces')}}
      </div>

    </div>
  </div>

</template>
<script>
import SidebarEngraving from "../../components/Client/SidebarEngraving.vue";
import ThreeCanvas from "../../components/Client/ThreeCanvas.vue";
import ThreeSceneEngraving from "../../components/Client/ThreeSceneEngraving.vue";
import Pages from "../../components/Client/Pages.vue";
import ElementEngravingSetting from "../../components/Client/Engravings/ElementEngravingSetting.vue";
import ElementsForEngraving from "../../components/Client/Engravings/ElementsForEngraving.vue";
export default {
  components: {
    ThreeSceneEngraving,
    SidebarEngraving,
    ThreeCanvas,
    Pages,
    ElementEngravingSetting,
    ElementsForEngraving,
  },
  name: "EngravingCanvas",
  created() {
    this.$store.dispatch("clientMain/setManageElement", null);
  },
  mounted() {
    if (this.activeFace) {
      this.$store.dispatch(
        "ClientEngravingSettings/setActiveElementId",
        this.activeFace.element_id
      );
    }
  },
  methods: {
    setActiveFace(face) {
      this.$store.dispatch("clientOrder/setActiveFace", face);
      this.$store.dispatch("ClientEngravingSettings/clear");
    },
  },
  computed: {
    activeElementId() {
      return this.$store.state.ClientEngravingSettings.activeElementId;
    },
    elementsForEngraving() {
      return this.$store.state.clientOrder.elements.filter(
        (el) => el.faces.length > 0
      );
    },
    faces() {
      if (this.activeElementId) {
        return this.$store.state.clientOrder.faces.filter(
          (f) => f.element_id == this.activeElementId
        );
      }
      return [];
    },
    activeFace() {
      const activeFace = this.$store.getters["clientOrder/activeFace"];

      return activeFace;
    },
    manageElement() {
      return this.$store.state.clientMain.manageElement;
    },

    showPanelElements() {
      return this.$store.state.clientMain.showPanelElements;
    },
  },
  watch: {
    activeElementId(elementId) {
      if (
        (this.activeFace && this.activeFace.element_id != elementId) ||
        !this.activeFace
      ) {
        this.setActiveFace(this.faces[0]);
      }
    },
  },
};
</script>
<style scoped>
.sidebar-content {
  grid-template-columns: max-content auto;
}
.sidebar-engraving-panel {
  width: 65px;
}
.engraving-canvas {
  display: grid;
  height: 100%;
  background-color: #d0d8d9;
}
.engraving-faces {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.engraving-faces-button {
  display: flex;
  background-color: #686d6e;
  height: 50px;
}
.engraving-faces-button.adaptive-view {
  display: none;
}
.engraving-faces-button.empty {
  align-items: center;
  padding: 15px;
  color: #fff;
}
.button-face {
  outline: none;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding: 0 15px;
  height: 50px;
  justify-content: center;
}
.button-face:hover {
  background-color: #535758;
}
.button-face.active {
  background-color: #10b981;
}
.button-face + .button-face {
  border-left: 1px solid #8e9798;
}
.button-face + .button-face.active,
.button-face.active + .button-face {
  border-left: 1px solid #10b981;
}
.engraving-canvas-draw {
  height: 100%;
}
@media screen and (max-width: 1000px) {
  .sidebar-content {
    grid-template-columns: auto;
  }
  .sidebar-engraving-panel {
    position: fixed;
    left: -9999px;
    top: 40px;
    bottom: 0;
    transition: all 0.4s;
    z-index: 40;
  }
  .sidebar-engraving-panel.open {
    left: 0;
  }

  .engraving-faces-button.desctop-view {
    display: none;
  }

  .engraving-faces-button.adaptive-view {
    display: flex;
    height: 32px;
  }

  .button-face {
    padding: 0 12px;
    height: 32px;
    font-size: 18px;
  }
  .engraving-faces-button.empty {
    height: 32px;
    font-size: 12px;
  }
}
</style>
